import * as React from 'react'
import { compose } from 'react-apollo'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { Dispatch } from 'redux'
import { Store, UserInfo, getUserInfo } from '../../reducers'
import styled from '../../theme/styled'
import LoginView from './LoginView'

const Selection = require('../Layout/selection_white.svg')

const DropDown = styled.li`
  display: flex;
  align-items: center;

  .dropdown {
    width: 100%;
    min-width: 12em;
    display: block;
    height: 60px;
  }

  .dropdownHead {
    margin-right: 1em;
    position: relative;
    top: 22px;
    text-align: center;
    text-decoration: underline;
    cursor: pointer;
  }

  .dropdownList {
    min-width: 12em;
    padding: 0.2em 1em;
    top: 44px;
    left: 0px;
    border: 1px solid ${({ theme }) => theme.colors.light};
    background: ${({ theme }) => theme.colors.invert};
    z-index: 2000;
    position: relative;
  }

  .dropdownElement {
    padding: 0.5em 0px;
    z-index: 2000;
  }

  .title {
    cursor: pointer;
  }

  .collapsed {
    display: none;
  }

  .active {
    background-image: url(${Selection});
    background-position: bottom center;
    background-repeat: no-repeat;
    background-size: 26px 13px;
    color: ${({ theme }) => theme.colors.brand};
  }

  /* Tooltip toggle styles start */
  #tooltipEl {
    cursor: pointer;
  }

  .switch {
    position: relative;
    float: right;
    display: inline-block;
    width: 35px;
    height: 18px;
    cursor: pointer;
  }

  .switch input {
    display: none;
  }

  .slider {
    position: absolute;
    display: block;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: all 0.4s;
    pointer-events: none;
    border-radius: 34px;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 14px;
    width: 14px;
    left: 2px;
    top: 2px;
    right: 2px;
    bottom: 2px;
    background-color: white;
    border-radius: 50%;
    transition: all 0.2s;
  }

  .toggleInput:checked + .slider {
    background-color: ${({ theme }) => theme.colors.brand};
  }

  .toggleInput:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }

  .toggleInput:checked + .slider:before {
    transform: translateX(17px);
  }
  /* Tooltip toggle styles end */

  .breaker {
    background: gray;
    margin-top: 8px;
    margin-bottom: 6px;
    width: 100%;
    height: 1px;
  }
`

type InputProps = {
  userInfo: UserInfo
} & RouteComponentProps<{}>

type ElemProps = {
  id?: string
  children?: React.ReactNode
  onClick?: () => void
  checked?: boolean
}

type State = {
  collapsed: boolean
  showTooltips: boolean
  showConfirmation: boolean
}

const DropDownElement: React.SFC<ElemProps> = (props: ElemProps) => {
  return (
    <li className="dropdownElement">
      <span id={props.id} onClick={props.onClick}>
        {props.children}
      </span>
    </li>
  )
}

const DropDownToggleElement: React.SFC<ElemProps> = (props: ElemProps) => {
  return (
    <li className="dropdownElement" id="tooltipEl" onClick={props.onClick}>
      <span className="title">Show tooltips</span>
      <label className="switch">
        <input id="tooltipsToggle" className="toggleInput" type="checkbox" />
        <span className="slider round" />
      </label>
    </li>
  )
}

const Breaker = () => {
  return <div className="breaker" />
}

class UserDropDown extends React.Component<InputProps, State> {
  el: HTMLLIElement | null

  constructor(props: InputProps) {
    super(props)
    this.state = {
      collapsed: true,
      showTooltips: true,
      showConfirmation: false
    }
    this.dropdownClicked = this.dropdownClicked.bind(this)
    this.goToProjectManager = this.goToProjectManager.bind(this)
  }

  toggleCollapsed = () => {
    this.setState({ collapsed: !this.state.collapsed })
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = e => {
    if (!this.el) {
      return
    }
    const area = ReactDOM.findDOMNode(this.el)

    if (!area.contains(e.target)) {
      this.setState({ collapsed: true })
      this.updateTooltipToggle()
    }
  }

  toggleTooltips() {
    const input = document.getElementById('tooltipsToggle') as HTMLInputElement
    if (input && input.type === 'checkbox') {
      input.checked = !input.checked
      localStorage.setItem('tooltips', JSON.stringify(input.checked))
    }
  }

  /* tslint:disable typedef */
  dropdownClicked(e) {
    /* tslint:enable typedef */
    if (this.state.collapsed) {
      this.setState({ collapsed: false })
    } else {
      const ddHead = document.getElementById('ddHead')
      if (ddHead && ddHead.contains(e.target)) {
        this.setState({ collapsed: true })
        this.updateTooltipToggle()
      }
    }
  }

  updateTooltipToggle() {
    const tooltipsOn = localStorage.getItem('tooltips')
    if (tooltipsOn !== 'false') {
      const toggleOn = tooltipsOn ? JSON.parse(tooltipsOn) : true
      const input = document.getElementById(
        'tooltipsToggle'
      ) as HTMLInputElement
      if (input && input.type === 'checkbox') {
        input.checked = toggleOn
      }
    }
  }

  showConfirmation = (show: boolean) => {
    this.setState({ showConfirmation: show })
    if (!show) {
      this.setState({ collapsed: true })
    }
  }

  goToProjectManager() {
    const { history, location } = this.props
    const path = location.pathname
    if (path.indexOf('/projects') >= 0) {
      history.replace('/projects')
    } else if (
      path.indexOf('/project/') >= 0 &&
      path.indexOf('/details/') >= 0
    ) {
      history.goBack()
    } else {
      history.push('/projects')
    }
    this.setState({ collapsed: true })
  }

  render() {
    const { userInfo } = this.props

    if (!userInfo) {
      return <LoginView />
    }

    const fullName =
      userInfo.fullName.trim().length !== 0
        ? userInfo.fullName
        : userInfo.username
    const { collapsed } = this.state

    return (
      <DropDown onClick={this.dropdownClicked} ref={el => (this.el = el)}>
        <div className={collapsed ? 'dropdown' : 'dropdown active'}>
          <div id="ddHead" className="dropdownHead">
            {fullName}
          </div>
          <div
            className={collapsed ? 'dropdownList collapsed' : 'dropdownList'}
          >
            <ul>
              <DropDownElement onClick={this.goToProjectManager}>
                <span className="title">Project manager</span>
              </DropDownElement>
              <DropDownElement id="loginEl">
                <LoginView
                  confirmationShown={this.state.showConfirmation}
                  showConfirmation={this.showConfirmation}
                />
              </DropDownElement>
              <Breaker />
              <DropDownToggleElement onClick={this.toggleTooltips} />
            </ul>
          </div>
        </div>
      </DropDown>
    )
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  userInfo: getUserInfo(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({})

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(UserDropDown)



// WEBPACK FOOTER //
// ./src/Components/Layout/UserDropDown.tsx